import FindBankAccountScreen from '../screens/FindBankAccount'
// import AppFindBankAccountScreen from '../screens/App-FindBankAccount'
import { NextPage } from 'next'
// import { isDesktop } from 'react-device-detect'

export const FindBankAccount: NextPage = () => {

  return (
    <>
      {/* {isDesktop ? (<FindBankAccountScreen />) : (<AppFindBankAccountScreen />)} */}
      <FindBankAccountScreen />
    </>
  )
}
